export const FULL_PERCENT = 100;
